module.exports = __webpack_public_path__ + "img/2.a37a5ab0.png";